import React, { useState, useEffect } from "react";
import "./tamperHeroSection.css";
import heroSectionTamperProof from "../images/heroSectionTamperproof.svg";
import heroSectionTamperProofMobile from "../images/heroSectionTamperProofMobile.svg";
import rotatingCircle from "../images/rotatingImage.svg";
import { isMobile } from "../utility/constand";
// import VerifyModal from "./VerifyModal";
// import AccountModal from "./AccountModal";

const TamperHeroSection = () => {
  const [isHovered, setIsHovered] = useState(false);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [isModalOpen2, setIsModalOpen2] = useState(false);

  const backgroundImage = isMobile
    ? heroSectionTamperProofMobile
    : heroSectionTamperProof;

  useEffect(() => {
    let timer;
    if (isHovered) {
      timer = setTimeout(() => {
        setIsHovered(false);
      }, 4000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isHovered]);
  const handleRedirectionToDashboard = () => {
    window.open("https://dashboard.tamperproof.co/", "_blank");
  };
  return (
    <>
      <div
        className="tamper-section"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* <div className="rotating-mask"> */}
        <div className="tamper-rotating-wrapper">
          <img
            src={rotatingCircle}
            alt="rotating decoration"
            className="tamper-rotating-image"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{ animationPlayState: isHovered ? "paused" : "running" }}
          />
        </div>

        {/* </div> */}
        <div className="tamper-section-content">
          <h1 className="tamper-section-heading">The Fastest Way</h1>
          <p className="tamper-section-main-text">
            to Prove a PDF wasn't Altered
          </p>
          <p className="tamper-section-text">
            Catch every hidden change: text, numbers, signatures or files
          </p>
          <div className="buttons">
            <button
              className="verify-now-btn"
              onClick={() => handleRedirectionToDashboard()}
            >
              Try For Free
            </button>
            {/* <button className="sample-report-btn" onClick={()=> setIsModalOpen2(true)}>Create Account</button> */}
          </div>
        </div>
        {/* <VerifyModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        /> */}
      </div>
      {/* <AccountModal
        isOpen={isModalOpen2}
        onClose={() => setIsModalOpen2(false)}
        product="tamperproof"
      /> */}
    </>
  );
};

export default TamperHeroSection;
